import { useMutation, useQueryClient } from '@tanstack/react-query';

type UpdateAdminUserParams = {
  id: number;
  name: string;
  email: string;
  role: string;
};

export default function useUpdateAdminUser() {
  const queryClient = useQueryClient();
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement | undefined)
    ?.content;

  return useMutation({
    mutationFn: async (params: UpdateAdminUserParams) => {
      const response = await fetch(`/admin/api/users/${params.id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token || '',
        },
        body: JSON.stringify({
          admin_user: {
            name: params.name,
            email: params.email,
            role: params.role,
          },
        }),
      });
      if (!response.ok) {
        const body = await response.json().catch(() => null);
        const message =
          body?.errors?.length > 0 ? body.errors.join(', ') : 'ユーザーの更新に失敗しました';
        throw new Error(message);
      }
      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'users'] });
    },
  });
}
